import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _ProductionResource } from "../../../core/services/dataBean/EntityCatalogVdos";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { ProductionResourceConstanstSelect } from "./ProductionResourceConstanstSelect";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { CostingCenterSelect } from "../../erp/cellEditor/CostingCenter/CostingCenterSelect";



export const ProductionResource = () => {

    const productionResource = useDataBean(_ProductionResource);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        productionResource.instance.getProductionResourceCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        productionResource.setBean({
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        productionResource.deleteItemVoid(productionResource.bean.IDProductionResource).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        productionResource.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProductionResource', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDStrName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Activo Fijo', property: 'FixedAssetItemName', visible: true },
        { title: 'Empleado', property: 'IDEmployee', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${productionResource.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Recursos Productivos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={productionResource.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">

                                <ProductionResourceConstanstSelect idSelector={productionResource.bean.Type} label="Tipo" onChange={(e) => productionResource.setBean({ ...productionResource.bean, "Type": e })} />
                            </div>
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={productionResource.bean.Name} onChange={productionResource.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable" jsonCode={productionResource.bean.AccountantIDStr} onChange={(e) => productionResource.setBean({ ...productionResource.bean, "AccountantIDStr": e.JsonCode })} />
                            </div>
                            <div className="col-md-6">
                                <CostingCenterSelect fKey="Code" idSelector={productionResource.bean.CostingCenterStr} onChange={(e) => { productionResource.setBean({ ...productionResource.bean, "CostingCenterStr": e }) }} label="Centro de Costo" />
                                {/* <SelectAccountantTree label="Centro de Costo" jsonCode={productionResource.bean.CostingCenterStr} onChange={(e) => productionResource.setBean({ ...productionResource.bean, "CostingCenterStr": e.JsonCode })} /> */}
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Description" className="form-control" value={productionResource.bean.Description} onChange={(e) => { productionResource.setBean({ ...productionResource.bean, 'Description': e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {productionResource.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}